<template>
  <div>
    <v-row>
      <v-col cols="12" lg="6">
          <v-row>
            <v-list-item>
              <v-btn
                v-if="GETTERS_INPUT_ALL.last_status_id < 8 && editable.buttons.add_to_team"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="add_to_team_dialog = true;">Добавить участника
              </v-btn>
            </v-list-item>

            <v-dialog v-model="add_to_team_dialog" max-width="40%">
              <user-search
                :attached_list="GETTERS_INPUT_ALL.all_teams"
                :full_view="false"
                @addUser="add_user_to_team($event)"
              />
            </v-dialog>
          </v-row>

          <v-row v-if="GETTERS_INPUT_ALL.all_teams && GETTERS_INPUT_ALL.all_teams.length > 0">
            <v-row style="margin: auto;" class="pa-0 ml-6">
                <p class="pt-1">
                  <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                  {{GETTERS_INPUT_ALL.applicant.individual.last_name}} {{GETTERS_INPUT_ALL.applicant.individual.first_name}} {{GETTERS_INPUT_ALL.applicant.individual.middle_name}}
                </p>
            </v-row>
            <v-row class="pa-0 ml-6" style="width: 100%;" v-for="(item, i) in GETTERS_INPUT_ALL.all_teams" v-if="item.is_active == true" :key="i">
              <p class="pt-1">
                <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                {{item.team_profile.individual.last_name}} {{item.team_profile.individual.first_name}} {{item.team_profile.individual.middle_name}}
              </p>
              <v-tooltip right v-if="(item.creator == GETTERS_CURRENT_USER.id) && GETTERS_INPUT_ALL.last_status_id < 8 && editable.buttons.add_to_team">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="red lighten-1"
                    @click="delete_from_team(item)"
                    style="margin-top: -16px !important; margin-left: 8px !important;">
                    mdi-delete
                    </v-icon>
                </template>
              <span>удалить</span>
              </v-tooltip>
            </v-row>
          </v-row>
          <v-row v-else>
            {{ $t('ModalCard.command_not_specified') }}
          </v-row>
        <div v-if="false && GETTERS_INPUT_ALL.last_status_id > 6 && GETTERS_INPUT_ALL.last_status_id < 11">
          <v-row>
            <b>Пропуска :</b>
          </v-row>
          <v-row>
            <div  class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;" v-for="(item, i) in listPasses" :key="i">
              <v-list-item>
                <template>
                  <p
                    class="subtitle-2 text-left"
                    @click="show_pass_card(item)"
                  >
                    <v-badge :color="status_descr(item.status, 'color')" :content="item.guests ? item.guests : ' - '" x-small overlap>
                      <v-chip :color="status_descr(item.status, 'color')" text-color="white">
                        <v-avatar left>
                          <v-icon color="white">mdi-card-account-details</v-icon>
                        </v-avatar>
                            <b style="color:white;">{{format_dateinterval(item)}}</b>
                      </v-chip>
                    </v-badge>
                  </p>
                </template>
              </v-list-item>
            </div>
          </v-row>
          <v-dialog v-model="pass_card_dialog" max-width="65%">
            <pass-modal-card/>
          </v-dialog>
        </div>
      </v-col>

      <v-col cols="12" lg="6" class="pt-0">
        <div>
          <div class="subtitle-2" style="align-items: flex-start;" v-if="GETTERS_INPUT_ALL.last_status_id > 4">
            <b>Запланирован эксперимент :</b>
            <div v-if="proposal_calendar.length == 0">
              <p>Даты еще не назначечны. Обратитесь за уточнением к ответственным по станции</p>
            </div>
            <template v-else>
              <div  class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;" v-for="(item, i) in proposal_calendar" :key="i">
                <v-list-item>
                  <template>
                    <p>
                      {{formate_datetimeinterval(item)}}
                    </p>
                  </template>
                </v-list-item>
              </div>
            </template>
          </div>

        </div>
      </v-col>
    </v-row>


  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import userSearch from '../Common/user-search/userSearch.vue'
import passModalCard from '../Common/Pass/userModalCard.vue'
export default {
  components: {
      userSearch,
      passModalCard,
  },

  name: 'ScheduleUserCard',

    props: {
        id: [String, Number],
        status_id: Number,
        editable: [Object, Array],
        idProposal: [String, Number],
    },
    computed: {
        ...mapGetters([
          'GETTERS_LOGIN',
          'GETTERS_INPUT_ALL',
          'GETTERS_CURRENT_USER',
          'GETTERS_BS_LIST',
        ]),
    },


    beforeMount() {
      this.preload();
    },

    mounted() {
    },
    
    data() {
        return {
            loaded: false,
            proposal_calendar: [],

            add_to_team_dialog: false,

          //PASSES
            listPasses: {},

            pass_card_dialog:false,
            current_pass: {},


          }
    },

    watch:{
      'GETTERS_INPUT_ALL.id'(val){
        this.preload();
      },
    },

    methods: {
      ...mapActions([
        'GET_PROPOSAL_LIST',
        'DELETE_CALENDAR_REC',
        'PROPOSAL_CHANGE_TEAM',
        'GET_LIST_PASSES',
        'NEW_PASS',
        'UPDATE_PASS',
        'GET_PASS_ALL',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
      ]),

      show_pass_card(pass){
        this.UPDATE_OVERLAY(true)
        this.GET_PASS_ALL(pass.id)
          .then(() => {
            this.UPDATE_OVERLAY(false)
            this.pass_card_dialog = true
          })        
      },
        
      preload(){
        if(this.GETTERS_INPUT_ALL.last_status_id > 4){
          this.load_proposal_calendars()
        }
        
        // this.load_passes()
      },

      load_passes(){
        if(this.GETTERS_INPUT_ALL.last_status_id > 6 && this.GETTERS_INPUT_ALL.last_status_id < 11){
          this.GET_LIST_PASSES({status_id: -1, view_type: 'proposal_done', proposal_id: this.GETTERS_INPUT_ALL.id})
            .then((res) => {
              console.log('PASS', res.data)
              this.listPasses = res.data;
            });
        }
      },


        status_descr(status, type){
          if(type == 'descr'){
            if (status == 4)
              return 'Черновик'
            else if (status == 0)
              return 'Запрошен'
            else if (status == 1)
              return 'Оформляется'
            else if (status == 2)
              return 'Готов'
            else if (status == 3)
              return 'Отменен'
            else
              return 'Не определен'
          }
          else{
            if (status == 0 || status == 4)
              return '#a9a9a9'
            else if (status == 1)
              return '#ada509'
            else if (status == 2)
              return '#1b8e30'
            else if (status == 3)
              return 'red lighten-2'
            else
              return 'red lighten-2'
          }
        },

        formate_datetimeinterval(item){
          var date_obj_1 = new Date(item.start_date)
          var date_obj_2 = new Date(item.finish_date)
          var diff = (date_obj_2 - date_obj_1) / 3600000

          return this.formate_datetime(date_obj_1) + ' : ' + this.formate_datetime(date_obj_2) + ' (' + diff.toFixed(1) + ' ч.)'
        },

        formate_datetime(date_obj){
          var month = date_obj.getMonth() + 1
          var date = date_obj.getDate()
          var m = date_obj.getMinutes()
          var h = date_obj.getHours()
          if (h<10) h = '0'+h
          if (m<10) m = '0'+m
          if (month<10) month = '0' + month
          if (date<10) date = '0' + date

          return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
        },

        format_dateinterval(item){
          var date_obj_1 = new Date(item.start_date)
          var date_obj_2 = new Date(item.finish_date)

          return this.formate_date(date_obj_1) + ' : ' + this.formate_date(date_obj_2)
        },

        formate_date(date_obj){
          var month = date_obj.getMonth() + 1
          var date = date_obj.getDate()
          if (month<10) month = '0' + month
          if (date<10) date = '0' + date

          return date + '.' + month + '.' + date_obj.getFullYear()
        },

        load_proposal_calendars(){
          this.GET_PROPOSAL_LIST({proposal_id:this.idProposal})
          .then((res) => {
            this.proposal_calendar = res;
          })
          .catch((e) => {
            console.log('eee', e);
            this.$messageHelper(e.message, 'error', 4000);
          });
        },

        add_user_to_team(profile_id){
          this.UPDATE_OVERLAY(true)
          this.PROPOSAL_CHANGE_TEAM({
            'type': 'add',
            'proposal_id': this.GETTERS_INPUT_ALL.id,
            'profile_id': profile_id,
          })
          .then((data) => {
            this.UPDATE_OVERLAY(false)
            if(data.error){
              this.$messageHelper(data.error, 'error', 3000);
            }
            else{
              this.add_to_team_dialog = false
            }
          })
        },

        delete_from_team(item){
          this.UPDATE_OVERLAY(true)
          this.PROPOSAL_CHANGE_TEAM({
            'type': 'delete',
            'proposal_id': this.GETTERS_INPUT_ALL.id,
            'users': {proposal_team_id: item.id},
          })
          .then((data) => {
            this.UPDATE_OVERLAY(false)
            if(data.error){
              this.$messageHelper(data.error, 'error', 3000);
            }
          })
        },

    }
}
</script>
<style>
    .bs-actions {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .bs-actions__text,
    .bs-actions__textarea {
        width: 100%;
        margin-left:0px;
        margin-right:15px;
        /* background-color:rgba(229,115,115,0.4); */
    }

    .bs-actions__text {
        padding: 15px 15px 0 15px;
        /* border: 1px solid red; */
        background-color:rgba(255,255,255,0);
        border-radius:8px;
        margin-top:20px;
    }

    .v-input--selection-controls {
        margin-top: 0;
    }
    .bs-actions__save {
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .date-interval .v-input__slot {
        margin-bottom: 0 !important;
    }
    .date-interval .v-messages {
        display: none !important;
    }
    .bs-actions__date{
        margin-left:0px;
        width:100%;
        background-color:rgba(255,255,255,0.9);
        border-radius:8px;
        padding: 0 15px 0 15px;
        margin-right:15px;
        margin-top:20px;
    }
</style>
